














import Vue from "vue";
import iwInputNumber from "@/encoding/components/buildingBlocks/InputNumber.vue";

export default Vue.extend({

    components: {
        iwInputNumber: iwInputNumber
    },
    data: function() {
        return {
            pathInStore: "property.building.streetFacadeWidth"
        };
    },
    computed: {
        facadeWidth: function(): string|null {
            const fWidth = this.$store.getters["FormModule/getValue"](this.pathInStore);
            if(fWidth) {
                return fWidth;
            }
            return "";
        },
        isDisplayed: function(): boolean {
            return ["HOUSE", "APARTMENT", "COMMERCIAL", "OFFICE", "INDUSTRY","GARAGE", "OTHER"].indexOf(this.getPropertyType()) !== - 1;
        },
    },
    methods: {
        updateValue: function(streetFacadeWidth: number): void {
            if (streetFacadeWidth == 0) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": streetFacadeWidth});
            }
        }
    }
});

